<template>
  <div class="header">
    <Header></Header>
    <!-- banner -->
    <div class="phoneAggreementPage">
        <div class="header">
          <p class="title">{{$t('productIndex.agreement')}}</p>
        </div>
        <div class="contain">
            <p class="downTxt t2em" v-html="content"></p>
        </div>
        <div class="footer">
          <span class="admitBtn"  @click="goProduct">同 意</span>
          <span class="cancelBtn" @click="goHome">不同意</span>
        </div>
    </div>
    <!-- footer -->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../../common/header';
import Footer from '../../common/footer';
export default {
  data() {
    return {
      isShowSearch:false,
      content:'',
    };
  },
  components: { Header,Footer },
  created(){
    var w = document.documentElement.clientWidth;
    if(w>1023){
      this.$router.push({  
            path: '/product',       
      });
    }
  },
  mounted(){
    this.getHegeTouzi();
  },
  methods: {
     // 获取合格投资者认定
    async getHegeTouzi() {
      const { data: res } = await this.$http.get("/article/getHegeTouzi.do");
          // 提示message
      if (res.code !== 200) return this.$message.error(res.message);
      this.content = res.data.content;
    },
    showSearch(){
      this.isShowSearch = !this.isShowSearch;
    },
    goHome(){
      this.$router.push({  
            path: '/',       
        });
      let navIndex = -1;
      localStorage.setItem('navIndex',navIndex);
    },
    goProduct(){
      this.$router.push({  
            path: '/phoneLogin',       
        })
    },
  }
};
</script>

<style lang="less" scoped>
.header{
  width: 100%;
    height: 100%;
  .phoneAggreementPage{
    width: 100%;
    height: 100%;
    padding-top: 10rem;
    .title{     
      font-size: 4.8rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #900211;
      line-height: 6.6rem;
      letter-spacing: 1px;
      padding:8rem 0;
      text-align: center;
    }
    .downTxt{
      color:#353535;
      font-size: 2.8rem;
      letter-spacing: 1px;
      line-height: 6rem;
    }
    .contain{
      padding:0 4rem;
      height: 60vh;
      overflow-y: scroll;
    }
    .contain::-webkit-scrollbar-track {
      background-color: #D8D8D8;
      -webkit-border-radius: 2em;
      -moz-border-radius: 2em;
      border-radius: 2em;
    }
    .contain::-webkit-scrollbar-thumb {
      background-color: #900211;
      -webkit-border-radius: 2em;
      -moz-border-radius: 2em;
      border-radius: 2em;
    }
    .footer{
      text-align: center;
      padding:8rem 0;
      background: #fff;
      span{
        width: 23.6rem;
        height: 8rem;
        background: #9A9A9A;
        line-height: 8rem;
        text-align: center;       
        font-size: 2.8rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        letter-spacing: 1rem;
        display: inline-block;
      }
      span:nth-of-type(1){
        margin-right: 4rem;
        background: #900211;
      }
    }
  }
}
</style>
